import { Component, Vue } from 'vue-facing-decorator';;
import { useCookies } from "vue3-cookies";
import AuthService from '@/services/AuthService';
import { ElMessage, ElNotification } from 'element-plus';
import { User, Lock } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';

@Component(
{
    components:
    {
        User,
        Lock,
        Header
    },
})

export default class Verify extends Vue 
{
    private environmentVersion = '';
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;
    private showButton : boolean = false;
    private loading : boolean = false;
    private token : string = '';
    private tokenArray : string[] = ['', '', '', '', '', '', '', '', ''] as string[];

    public async mounted()
    {
        this.environmentVersion = process.env.VUE_APP_VERSION;
        this.token = this.$route.params.token as string;

        if (this.token && this.token.length == 6)
        {
            for (let i = 0; i < 6; i++)
            {
                this.tokenArray[i] = this.token.substr(i,1);
            }

            this.showButton = true;
        }
        
        window.addEventListener('resize', this.onWindowResize);
        window.addEventListener('paste', this.onClipboardPaste);
        window.scrollTo(0,0);
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
        window.removeEventListener('paste', this.onClipboardPaste);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    public onClipboardPaste(event : ClipboardEvent)
    {
        let token : string = event.clipboardData.getData('text');

        let el : HTMLInputElement = document.getElementById("token-0") as HTMLInputElement;

        if (el)
        {
            el.focus();
        }

        if (token && token.length == 6)
        {
            for (let i:number = 0; i < 6; i++)
            {
                this.tokenArray[i] = token.substr(i,1);                
            }

            this.token = token;
        }

        this.checkToken();
    }

    public onKeyDown(event : any, index : number)
    {
        if (event.keyCode == 13)
        {
            this.onSubmit();
            return;
        }

        if (index > 0 && event.keyCode == 8 && this.tokenArray[index].length == 0)
        {
            let el : HTMLInputElement = document.getElementById("token-" + (index-1)) as HTMLInputElement;
    
            if (el)
            {
                el.focus();
            }

            this.token = '';
            for (let i : number = 0; i < index-1; i++)
            {
                this.token += this.tokenArray[i];
            }

        }

        this.checkToken();
    }
	
	private async verifyToken()
    {
        // request participation
        let ok = await AuthService.verify(this.token);

        if (ok)
        {
            // lookup user in database and verify
            let userModel : UserModel = await AuthService.verify(this.token);

            // if user exists, load permissions and show start page
            if (userModel)
            {
                await AuthService.getPermissions();
                this.$router.push(`/`);
                return;
            }
        }

        // in case login was not successful, show error message
        ElNotification(
        {
            title: 'Fehler',
            message: 'Der von Ihnen eingegebene Bestätigungs-Code ist entweder ungültig, oder es sind seit Aufforderung mehr als 10 Minuten vergangen.',
            type: 'error',
            offset: 16,
            duration: 5000
        });
    }

	private checkToken()
    {
        this.showButton = false;

        if (this.token.length == 6)
        {
            for (let i : number = 0; i < 6; i++)
            {
                if (this.tokenArray[i].length == 0)
                {
                    return;
                }
            }

            this.showButton = true;
        }
    }
    
    private onTokenEnter(inputEvent : HTMLInputEvent, index : number)
    {
        if (!inputEvent.data) 
        {
            this.checkToken();
            return;
        }

        let data : string | undefined = inputEvent.data;
		
        // if only only one character is enered, store it and move to next one
        if (data.length == 1)
        {
            this.tokenArray[index] = this.tokenArray[index].toUpperCase();

            if (index < 5)
            {
                let el : HTMLInputElement = document.getElementById("token-" + (index+1)) as HTMLInputElement;
    
                if (el)
                {
                    el.focus();
                }   
            }
        }

        this.token = '';
        for (let i : number = 0; i < 6; i++)
        {
            this.token += this.tokenArray[i];
        }

        this.checkToken();
    }

    private onSubmit()
    {
        if (this.token.length == 6)
        {
            this.verifyToken();
        }
        else
        {
            // or show error message
            ElNotification(
            {
                title: 'Fehler',
                message: 'Der von Ihnen eingegebene Code ist ungültig. Bitte versuchen Sie es erneut.',
                type: 'error',
                offset: 16
            });
        }
    }

    private onReturnClick()
    {
        this.$router.push("/login");
    }
};

